import React,{useEffect,useState} from 'react';
import {Alert,CircularProgress} from '@mui/material';
import {TokenValidator} from '../../../utils';
import {createTrackingApi} from '../../../controllers/trackingV2';
import {createTrackingJournal} from '../../../utils/trackingJournal';
import Panel from './trackingCapturePanel';

// Shared session boundary for production and the two independent QA screens.
// Decoding supplies a local storage namespace only; the backend verifies JWT.
export default function TrackingSession({station,source='AUTO',machineId,onLegacy,onRegistered,onPending=()=>{},storage,validator=TokenValidator,lockManager=navigator.locks}){
 const [session,setSession]=useState(null),[error,setError]=useState('');
 useEffect(()=>{
  let alive=true,release;setSession(null);setError('');
  (async()=>{try{
   const token=await validator.GetStaffUser();
   if(!token||!await validator.ValidTokenDate(token))throw Error('AUTH_REQUIRED');
   const payload=await validator.SimplifyToken(token),actorId=Number(payload.id!==undefined?payload.id:payload.user_data?.id);
   if(!Number.isSafeInteger(actorId)||actorId<1)throw Error('AUTH_REQUIRED');
   const journal=createTrackingJournal(storage||window.localStorage,actorId);
   const api=createTrackingApi({getToken:async()=>{
    const current=await validator.GetStaffUser();
    // Do not send a journal owned by the previous account under a new JWT.
    if(current!==token||!await validator.ValidTokenDate(current))throw Object.assign(Error('La sesión cambió. Vuelve a iniciar sesión antes de continuar.'),{code:'AUTH_REQUIRED'});
    return current;
   }});
   if(!lockManager||typeof lockManager.request!=='function')throw Error('TAB_LOCK_UNAVAILABLE');
   // Hold one browser-origin lock for this actor for the mounted scanner's
   // lifetime. Journal read/write and network retry stay inside this ownership.
   await lockManager.request(`mes.tracking-v2.actor.${actorId}`,{mode:'exclusive',ifAvailable:true},async lock=>{
    if(!alive)return;
    if(!lock){setError('Esta cuenta ya tiene un escáner abierto en otra pestaña. Ciérralo antes de continuar.');return;}
    const held=new Promise(resolve=>{release=resolve;});
    setSession({actorId,journal,api});await held;
   });
  }catch(e){if(alive)setError(e.message==='TAB_LOCK_UNAVAILABLE'?'Este navegador no permite proteger el escaneo entre pestañas. Usa el portal HTTPS en un navegador compatible.':'No se pudo validar la sesión o su almacenamiento. Inicia sesión nuevamente.');}})();
  return()=>{alive=false;if(release)release();};
 },[storage,validator,lockManager]);
 if(error)return <Alert severity='error'>{error}</Alert>;
 if(!session)return <CircularProgress size={24} aria-label='Validando sesión de escaneo'/>;
 return <Panel key={session.actorId} station={station} source={source} machineId={machineId} journal={session.journal} preview={session.api.preview} commit={session.api.commit} onLegacy={onLegacy} onPending={onPending} onRegistered={onRegistered}/>;
}
